import { CSSProperties } from 'react';
import cn from 'classnames';
import styles from './Icon.module.css';

interface Props {
  name: string;
  className?: string;
  style?: CSSProperties;
  size?: number;
}

const Icon = (props: Props) => {
  const { name, className, style, size } = props;

  return (
    <span
      className={cn('material-symbols-outlined', styles.Icon, className)}
      style={{ ...style, fontSize: size || style?.fontSize }}
      data-testid="Icon"
    >
      {name}
    </span>
  );
};

export default Icon;
